import { useState } from 'react';
import { OpenTicket } from './useOpenTickets';

interface Props {
  tickets: OpenTicket[];
}

export function OpenTicketsPanel({ tickets }: Props) {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  if (tickets.length === 0) return null;

  const active = tickets.filter(t => t.status !== 'resolved');
  const recentlyResolved = tickets.filter(t => t.status === 'resolved');

  return (
    <div className="chat-tickets-panel">
      {active.length > 0 && (
        <div className="chat-tickets-group">
          <h4 className="chat-tickets-heading">Your Open Tickets</h4>
          {active.map(t => (
            <TicketRow
              key={t.id}
              ticket={t}
              expanded={expandedId === t.id}
              onToggle={() => setExpandedId(expandedId === t.id ? null : t.id)}
            />
          ))}
        </div>
      )}
      {recentlyResolved.length > 0 && (
        <div className="chat-tickets-group">
          <h4 className="chat-tickets-heading">Recently Resolved</h4>
          {recentlyResolved.map(t => (
            <TicketRow
              key={t.id}
              ticket={t}
              expanded={expandedId === t.id}
              onToggle={() => setExpandedId(expandedId === t.id ? null : t.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

interface TicketRowProps {
  ticket: OpenTicket;
  expanded: boolean;
  onToggle: () => void;
}

function TicketRow({ ticket, expanded, onToggle }: TicketRowProps) {
  const created = ticket.createdAt
    ? new Date(ticket.createdAt.seconds * 1000).toLocaleString()
    : '';
  const statusLabel: Record<OpenTicket['status'], string> = {
    open: 'Opened',
    acknowledged: 'Acknowledged',
    investigating: 'Investigating',
    resolved: 'Resolved',
  };

  return (
    <div className={`chat-ticket-row chat-ticket-${ticket.status}`}>
      <button className="chat-ticket-summary" onClick={onToggle} aria-expanded={expanded}>
        <code className="chat-ticket-id">{ticket.id}</code>
        <span className="chat-ticket-status">{statusLabel[ticket.status]}</span>
        <span className="chat-ticket-time">{created}</span>
      </button>
      {expanded && (
        <div className="chat-ticket-body">
          <p>
            <b>What we heard:</b> {ticket.userComplaint}
          </p>
          {ticket.status === 'resolved' && ticket.resolutionNote ? (
            <div className="chat-ticket-resolution">
              <b>Resolution:</b> {ticket.resolutionNote}
            </div>
          ) : (
            <p className="chat-ticket-pending-msg">
              The team has the full details. We'll update you here once it's resolved.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
